import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/pinia/auth'
import { getRealmFromSubDomain } from './services/oidc.service'
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/oauth2', // Needs to match redirectUri (redirect_uri if you use snake case) in your oidcSettings
      name: 'oidcCallback',
      component: () => import('@/pages/authentication/Redirect.vue')
    },
    {
      path: '/silentrenew', // Needs to match silentRedirectUri in your oidcSettings
      name: 'silentrenew',
      component: () => import('@/pages/authentication/SilentRenew.vue')
    },
    {
      // iBinder OAuth2 callback. Must match the redirect_uri registered with iBinder.
      // requiresAuth so the user's Keycloak token is available for the backend exchange.
      path: '/ibinder-callback',
      name: 'ibinderCallback',
      component: () => import('@/pages/authentication/IBinderRedirect.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/info',
      name: 'info',
      component: () => import('@/pages/SplashScreen.vue')
    },
    {
      path: '/realm',
      name: 'realm',
      component: () => import('@/pages/RealmPage.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/:pathMatch(.*)*',
      name: 'home',
      component: () => import('@/pages/HomePage.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      name: 'landingpage',
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      redirect: (to) => {
        const internalZynkaUser = localStorage.getItem('internalZynkaUser') === 'true'
        const atInternalDomain = !getRealmFromSubDomain()

        if (internalZynkaUser || !atInternalDomain) {
          return { name: 'home' }
        }
        return { name: 'info' }
      }
    },
    // Below, Instance refers to Ivion site, which was previously called IndoorViewer instance in this project
    // IndoorViewer was NavVis' old product name and, at that time, an instance was somewhat similar to an Ivion site
    {
      path: '/instance/:pathMatch(.*)*',
      name: 'instance',
      component: () => import('@/pages/Instance.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'pageNotFound',
      component: () => import('@/pages/PageNotFound.vue')
    }
  ]
})

// First middleware: Check authentication
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const authStore = useAuthStore()
    // Check in-memory user first; fall back to session storage only when null.
    const user = authStore.user ?? (await authStore.getUser())
    if (user && !user.expired) {
      next()
    } else {
      try {
        // Preserve the target URL (incl. any query params) across the Keycloak
        // round-trip so Redirect.vue can restore it instead of dropping to /home.
        // /realm is exempt: it is the post-logout landing page, not a place the
        // user asked to go, so returning to it would strand customer-subdomain
        // users on the realm picker. Let Redirect.vue resolve the realm instead.
        await authStore.signinRedirect(to.name === 'realm' ? undefined : to.fullPath)
      } catch (e) {
        console.error('signinRedirect failed', e)
        next(false)
      }
    }
  } else {
    next()
  }
})

export default router
